{
  "version": 1,
  "asset_id": "7e936a95-1323-44b4-a924-db171dd6bd87",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/7e936a95-1323-44b4-a924-db171dd6bd87/destination-roofing-owner-sales-team-crystal-river-fl-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/7e936a95-1323-44b4-a924-db171dd6bd87/destination-roofing-owner-sales-team-crystal-river-fl-1200w.avif",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-1200w.avif",
  "size": 43623,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:45Z"
}
